import { Avatar } from '../Avatar';
import AvatarFallbackIcon from './avatarFallbackIcon.svg?component';
import type { AvatarProps } from '../Avatar';

export const AvatarFallback = ({ children, ...props }: AvatarProps) => (
    <Avatar {...props}>{children || <AvatarFallbackIcon width="100%" height="100%" />}</Avatar>
);
